import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getGastos,
  deleteGasto,
  getGastoById,
} from "../helpers/rutaGastos";
import ModalGasto from "./ModalGasto";
import "../css/tableclientes.css";

const TableGastos = () => {
  const [gastos, setGastos] = useState({
    data: {},
    loading: true,
  });

  const [gasto, setGasto] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaGastos();
  }, []);

  const consultaGastos = () => {
    getGastos().then((datos) => {
      console.log("📦 Gasto:", datos);
      setGastos({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaGastos();
  };

  const handleShow = () => setShow(true);

  const modificaGasto = (id) => {
    getGastoById(id).then((resp) => {
      if (resp.ok) {
        setGasto(resp.gasto); // ✅ ahora sí solo el objeto gasto
        handleShow();
      } else {
        console.error("❌ Error al obtener gasto:", resp.error);
      }
    });
  };

  const eliminarGasto = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar el gasto?");
    if (confirmar) {
      deleteGasto(id).then(() => {
        consultaGastos();
      });
    }
  };

  return (
    <div className="table-container">
      {!gastos.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Gasto</th>
                </tr>
              </thead>
              <tbody>
                {gastos.data.gastos.map((gasto) =>
                  gasto.activo ? (
                    <tr key={gasto._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaGasto(gasto._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarGasto(gasto._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{gasto.codgas}</td>
                      <td>{gasto.gasto}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalGasto
            show={show}
            handleClose={handleClose}
            gasto={gasto}
          />
        </>
      )}
    </div>
  );
};

export default TableGastos;
